import { FC } from "react";
import { TooltipIconButton } from "./tooltip-icon-button";
import { ArrowDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  disabled?: boolean;
  onClick?: () => void;
}

/**
 * Floating control that appears to quickly jump to the latest message.
 * Hidden when `disabled` is true (e.g., when already at the bottom).
 */
const ThreadScrollToBottom: FC<Props> = ({ disabled, onClick }) => {
  return (
    <TooltipIconButton
      tooltip="Scroll to bottom"
      className={cn("bg-gray-100 dark:bg-background dark:hover:bg-accent absolute -top-12 z-10 self-center rounded-full p-4", disabled ? "invisible" : "")}
      onClick={onClick}
    >
      <ArrowDownIcon />
    </TooltipIconButton>
  );
};

export default ThreadScrollToBottom;
